module.exports = __webpack_public_path__ + "static/media/fondo_puesta_en_escena.ef78e0be.jpg";